import cn from 'classnames';
import * as React from 'react';
import { noop } from 'underscore';

import { YoutubeCategorySelectorOption } from './types';
import { block } from './utils';

export interface CategoryOptionProps {
  className?: string;
  option: YoutubeCategorySelectorOption;
  onClick?: (value: any) => void;
  selected?: boolean;
}

const { useCallback } = React;

const CategoryOption: React.FC<CategoryOptionProps> = ({
  className,
  onClick,
  option,
  selected,
}) => {
  const { label, value } = option || {};
  const handleClick = useCallback(() => onClick(value), [onClick, value]);

  return (
    <div
      className={cn(block('option', { selected }), className)}
      onClick={handleClick}
    >
      <span className={block('option-label')}>{label}</span>
    </div>
  );
};

CategoryOption.defaultProps = {
  onClick: noop,
  selected: false,
};

export default CategoryOption;
